export const GET_NEW_REGISTER = "[NEW_REGISTER] GET_NEW_REGISTER";
export const GET_NEW_REGISTER_SUCCESS = "[USER] GET_NEW_REGISTER_SUCCESS";
export const GET_NEW_REGISTER_FAILED = "[USER] GET_NEW_REGISTER_FAILED";

export const DELETE_NEW_REGISTER = "[NEW_REGISTER] DELETE_NEW_REGISTER";
export const DELETE_NEW_REGISTER_SUCCESS = "[USER] DELETE_NEW_REGISTER_SUCCESS";
export const DELETE_NEW_REGISTER_FAILED = "[USER] DELETE_NEW_REGISTER_FAILED";